var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgPatternRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 241,
    viewBox: "0 0 37 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 42.1353L0 54.6313L16.7267 0.382797H12.8735L0 42.1353ZM3.57114 0.382797L0 11.9647L0 0.382797H3.57114ZM26.0289 0.382797L0 84.802L0 97.298L29.8822 0.382797H26.0289ZM39.1845 0.382797L0 127.469L0 139.965L43.0377 0.382797H39.1845ZM52.34 0.382797L0 170.135L0 182.632L56.1933 0.382797H52.34ZM65.4956 0.382797L0 212.802L0 225.298L69.3489 0.382797H65.4956ZM74 15.4687L4.65125 240.383H8.50447L74 27.9647V15.4687ZM74 58.1353L17.8068 240.383H21.66L74 70.6313L74 58.1353ZM74 100.802L30.9623 240.383H34.8155L74 113.298V100.802ZM74 143.469L44.1178 240.383H47.9711L74 155.965V143.469ZM74 186.135L57.2734 240.383H61.1266L74 198.632V186.135ZM74 228.802L70.4289 240.383H74V228.802Z",
    fill: "#008894"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternRight);
export default __webpack_public_path__ + "static/media/bg-pattern-right.af74b7de6f82b642c7e91031673fa63d.svg";
export { ForwardRef as ReactComponent };